<ng-container [ngSwitch]="props['variant']">
	<button *ngSwitchCase="'flat'" [attr.id]="id" mat-flat-button [color]="props['color']" (click)="onClick()">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</button>
	<button *ngSwitchCase="'stroked'" [attr.id]="id" mat-stroked-button [color]="props['color']" (click)="onClick()">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</button>
	<button *ngSwitchCase="'basic'" [attr.id]="id" mat-button [color]="props['color']" (click)="onClick()">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</button>
	<button *ngSwitchDefault [attr.id]="id" mat-raised-button [color]="props['color']" (click)="onClick()">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</button>
</ng-container>

<ng-template #content>
	<div class="one-line">
		<fa-icon *ngIf="props['icon']" [icon]="props['icon']" style="margin-right: 8px"></fa-icon>
		{{ props.label || 'Go Back' }}
	</div>
</ng-template>
